import AccountService from "../../../services/account.service";
import {toast} from "react-hot-toast";

const DeleteUserModal = ({user, onClose, onDeleted}) => {
    
    const handleDelete = async () => {
        const promise = AccountService.disablelifewhereuser(user.email, user.userId);
        toast.promise(promise, {
            loading: 'Sending changes...',
            success: 'The user was deleted successfully!',
            error: (err)=> err.message || 'Failed to delete the user!'
        });

        try {
            await promise;
        }catch(error) {
            console.log(error);
        }finally {
            onDeleted();
            onClose();
        }
    };

    return (
        <div className="modal" style={{display: user ? "block" : "none"}}>
            <div className="modal-wrapper"
                 style={{
                     transform: user ? 'translateY(0vh)' : 'translateY(-100vh)',
                     opacity: user ? '1' : '0'
                 }}>

                <div className="modal-header">
                    <h3>Delete User</h3>
                    <span className="close-modal-btn" onClick={onClose}>×</span>
                </div>

                <div className="modal-body">
                    <p>Are you sure you want to delete the user <strong>{user?.firstName} {user?.lastName}</strong>?</p>
                </div>

                <div className="modal-footer">
                    <button className="secondary-btn btn-small" onClick={onClose}>Cancel</button>
                    <button className="primary-btn btn-small" onClick={handleDelete}>Delete</button>
                </div>
            </div>
        </div>
    );
}

export default DeleteUserModal;